export const allTasksCompleteBillboardTemplate = /* html */ `
  <div
    class="tour-all-tasks-complete d-flex align-items-center justify-content-center position-relative py-3 px-2"
  >
    <div>
      <header class="text-center mb-3">
        <h2 class="display-2 fw-semibold mb-4">{{title}}</h2>
        <h3>{{subtitle}}</h3>
      </header>

      <div class="mb-5">
        <div class="row g-4">
          <div class="col-6">
            <a href="https://developer.trimblemaps.com/restful-apis/account-manager/account-manager-api/" target="_blank">
              <div class="card rounded-0 h-100 shadow">
                <img src="/assets/img/all-tasks-complete-card-1.png" style="aspect-ratio: 1338 / 619" class="card-image card-img-top rounded-0 img-fluid" alt="A screenshot of the Trimble Developer Portal website.">
                <div class="card-body">
                  <h5 class="card-title fw-bold">{{card1Title}}</h5>
                  <small>{{card1Text}}</small>
                </div>
              </div>
            </a>
          </div>

          <div class="col-6">
            <a href="https://learn.transportation.trimble.com/discover/result/?sub=LC/public/accountmanageronlinehelp/&tl=Account-Manager-Table-of-Contents&q=212876" target="_blank">
              <div class="card rounded-0 h-100 shadow">
                <img src="/assets/img/all-tasks-complete-card-2.png" style="aspect-ratio: 1338 / 619" class="card-image card-img-top rounded-0 img-fluid" alt="A screenshot of the Trimble Support Website for Account Manager.">
                <div class="card-body">
                  <h5 class="card-title fw-bold">{{card2Title}}</h5>
                  <small>{{card2Text}}</small>
                </div>
              </div>
            </a>
          </div>

          <div class="col-6">
            <a href="https://www.youtube.com/watch?v=Uc5rOl92Gxc" target="_blank">
              <div class="card rounded-0 h-100 shadow">
                <img src="/assets/img/all-tasks-complete-card-3.png" style="aspect-ratio: 1338 / 619" class="card-image card-img-top rounded-0 img-fluid" alt="A screenshot of the Trimble Support Website for Account Manager.">
                <div class="card-body">
                  <h5 class="card-title fw-bold">{{card3Title}}</h5>
                  <small>{{card3Text}}</small>
                </div>
              </div>
            </a>
          </div>

          <div class="col-6">
            <a href="/" target="_blank">
              <div class="card rounded-0 h-100 shadow">
                <img src="/assets/img/all-tasks-complete-card-4.png" style="aspect-ratio: 1338 / 619" class="card-image card-img-top rounded-0 img-fluid" alt="A screenshot of the Trimble Support Website for Account Manager.">
                <div class="card-body">
                  <h5 class="card-title fw-bold">{{card4Title}}</h5>
                  <small>{{card4Text}}</small>
                </div>
              </div>
            </a>
          </div>

        </div>
      </div>

      <div class="position-absolute bottom-0 end-0">
        <button
          type="button"
          class="btn btn-primary btn-lg px-4"
          data-tour-action-key="nextButton"
        >
          {{nextButtonText}}
        </button>
      </div>
    </div>
  </div>`;
